module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgZmlsbD0ibm9uZSIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cGF0aCBkPSJNMjEgMjQuMDYybC0uMDYzLS40OTZBOC41IDguNSAwIDAgMCAxMy41IDMydi41aC41IDE2IC41VjMyYzAtNC4zMzUtMy4yNDUtNy45MTEtNy40MzgtOC40MzRsLS41NjItLjA3di41NjZWMjkuNWgtMXYtNS40MzhIMjF6TTE1LjUgMTdhNi41IDYuNSAwIDEgMCAxMyAwIDYuNSA2LjUgMCAxIDAtMTMgMHoiIGZpbGw9IiMwNGM4YzgiIHN0cm9rZT0iIzcwQTE0RiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/corporate/pengguna.svg
// module id = sWpC
// module chunks = 215